/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_IntroInputs */

const en_minifier_ref_intro = /** @type {(inputs: Minifier_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same document at each stage, measured with Node and zlib defaults. Reproduce it yourself before trusting any minification claim, including this one.`)
};

const ko_minifier_ref_intro = /** @type {(inputs: Minifier_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`같은 문서를 단계별로 Node와 zlib 기본 설정으로 측정한 값입니다. 이 글의 주장을 포함해 어떤 압축률 주장이든 직접 재현해보고 믿으세요.`)
};

const ja_minifier_ref_intro = /** @type {(inputs: Minifier_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ文書を段階ごとに Node と zlib の既定設定で測った値です。この記事の主張を含め、どんな圧縮率の主張も自分で再現してから信じてください。`)
};

/**
* | output |
* | --- |
* | "The same document at each stage, measured with Node and zlib defaults. Reproduce it yourself before trusting any minification claim, including this one." |
*
* @param {Minifier_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_intro = /** @type {((inputs?: Minifier_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_intro(inputs)
	if (locale === "ko") return ko_minifier_ref_intro(inputs)
	return ja_minifier_ref_intro(inputs)
});